import API from 'types/api';
import APP from 'types/app';
import _ from 'lodash';

const REQUEST_STATE = {
  IDLE: 'idle',
  LOADING: 'loading',
  COMPLETE: 'complete',
  FAILED: 'failed', // restore failed
  ERROR: 'error', // error in request, status code !== 200
  PHONE_VALIDATION: 'phoneValidation',
  ENTER_PASSWORD: 'enterPassword',
};

const initialState = {
  requestState: REQUEST_STATE.IDLE,
  errors: null,
  message: '',
};

export default (state = initialState, { type, payload }) => {
  let newState;
  switch (type) {
    case API.POST_RESTORE_FETCH:
      return {
        ...state,
        requestState: REQUEST_STATE.LOADING,
        errors: null,
      };
    case API.POST_RESTORE_SUCCESS:
      if (
        _.get(payload, 'status.completion') === 'complete' ||
        (_.get(payload, 'status.completion') === 'incomplete' &&
          _.get(payload, 'status.proceed_to') === 'email_verification')
      ) {
        newState = {
          ...state,
          requestState: REQUEST_STATE.COMPLETE,
          message: _.get(payload, 'status.message', state.message),
          errors: null,
        };
      } else if (
        _.get(payload, 'status.completion') === 'incomplete' &&
        _.get(payload, 'status.proceed_to') === 'phone_verification'
      ) {
        newState = {
          ...state,
          requestState: REQUEST_STATE.PHONE_VALIDATION,
          message: _.get(payload, 'status.message', state.message),
          errors: null,
        };
      } else if (
        _.get(payload, 'status.completion') === 'incomplete' &&
        _.get(payload, 'status.proceed_to') === 'set_password'
      ) {
        newState = {
          ...state,
          requestState: REQUEST_STATE.ENTER_PASSWORD,
          message: _.get(payload, 'status.message', state.message),
          errors: null,
        };
      } else {
        newState = {
          ...state,
        };
      }
      return newState;
    case API.POST_RESTORE_ERROR:
      if (payload.code === 200) {
        if (_.get(payload, 'response.errors.0.code') === 'sms.verification_code.not_match') {
          payload.response.errors[0].field = 'login';
        }
        newState = {
          ...state,
          requestState: REQUEST_STATE.FAILED,
          errors: payload.response.errors,
        };
      } else {
        newState = {
          ...state,
          requestState: REQUEST_STATE.ERROR,
          errors: null,
          message: '',
        };
      }
      return newState;
    case APP.RESET_SERVICE_API_DATA:
      if (payload === 'restore') {
        return {
          ...initialState,
        };
      }
      return state;
    case APP.REMOVE_API_RESPONSE_ERROR:
      if (payload.type === 'restore' && _.isArray(state.errors) && state.errors.length > 0) {
        return {
          ...state,
          errors: state.errors.reduce((prev, item) => {
            if (item.field !== payload.field) {
              prev.push(item);
            }
            return prev;
          }, []),
        };
      }
      return state;
    default:
      return state;
  }
};
